export default "__VITE_ASSET__ac783f7e__"